/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

import PageBanner from "../Components/PageBanner"; // Import PageBanner

import blogImage1 from "../assets/images/all-img/Blog-1.webp"; // Blog 1 image
import blogImage2 from "../assets/images/all-img/Blog-2.webp"; // Blog 2 image
import blogImage3 from "../assets/images/all-img/Blog-3.webp"; // Blog 3 image
import usePageTracker from "../hooks/usePageTracker";

const Blogs = () => {
  const { t } = useTranslation(); // Initialize translation
  usePageTracker("page_view_blogs");

  // Blog IDs and their respective images
  const blogData = [
    { id: "1", image: blogImage1 },
    { id: "2", image: blogImage2 },
    { id: "3", image: blogImage3 },
  ];

  return (
    <>
      <Helmet>
        <title>{t("seo.blogs_title")}</title>
        <meta
          name="description"
          content="Learn more about Online Institute, our mission, our team, and the educational values we bring to your learning experience."
        />
        <meta property="og:title" content="About Us | Online Institute" />
        <meta
          property="og:description"
          content="Explore the story and mission of Online Institute — where online education meets excellence and flexibility."
        />
        <meta
          property="og:image"
          content="https://pre-onlineinstitute.mediafactoryworld.com/assets/images/og-image.jpg"
        />
        <meta
          property="og:url"
          content="https://pre-onlineinstitute.mediafactoryworld.com/about"
        />
        <meta name="twitter:title" content="About Online Institute" />
        <meta
          name="twitter:description"
          content="Discover our values, team, and how we deliver quality education to students across the globe."
        />
      </Helmet>
      <PageBanner
        title={t("blogs.page_title")}
        pageName={t("blogs.page_name")}
      />

      <div className="section-padding bg-[url('../images/all-img/section-bg-5.png')] bg-cover bg-no-repeat bg-center mt-5">
        <div className="container mt-5">
          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px] pt-7">
            {blogData.map((blog) => (
              <div
                className="bg-white shadow-box5 rounded-[8px] transition duration-100 hover:shadow-box3"
                key={blog.id}
              >
                {/* Blog Image */}
                <div className="course-thumb h-[260px] rounded-t-[8px] relative">
                  <img
                    src={blog.image} // Use dynamic blog image
                    alt={`Blog ${blog.id}`}
                    className="w-full h-full object-cover rounded-t-[8px]"
                  />
                </div>

                {/* Blog Content */}
                <div className="course-content p-8">
                  {/* Blog Title */}
                  <h4 className="text-xl mb-5 font-bold">
                    <Link
                      to={`/blogs/${blog.id}`}
                      className="text-primary transition duration-150"
                    >
                      {t(`blog_articles.${blog.id}.title`)}
                    </Link>
                  </h4>

                  {/* Read More */}
                  <Link
                    to={`/blogs/${blog.id}`}
                    className="text-black hover:text-primary font-semibold hover:underline transition duration-150"
                  >
                    {t("blog_articles.read_more")}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Blogs;
